export * from './angularfire2';
//# sourceMappingURL=public_api.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularfire2/public_api.js
// module id = 1400
// module chunks = 21